const TicketSeatReservationModes = {
	NotAllowed: -1,
	Unknown: 0,
	CustomerSelectionAllowed: 1,
	CustomerSelectionMandatory: 2,
	RailwayAllocated: 3
};

const allowsCustomerSelection = mode => {
	return [
		TicketSeatReservationModes.CustomerSelectionAllowed,
		TicketSeatReservationModes.CustomerSelectionMandatory
	].includes(mode);
};

const allowsRailwaySelection = mode => {
	return [
		TicketSeatReservationModes.RailwayAllocated
	].includes(mode);
};

const requiresCustomerSelection = mode => {
	return (mode === TicketSeatReservationModes.CustomerSelectionMandatory);
};

export {
	allowsCustomerSelection,
	allowsRailwaySelection,
	requiresCustomerSelection,
	TicketSeatReservationModes as values
};

export default TicketSeatReservationModes;
